/**
 * Utilities for parsing and handling external links
 */

/**
 * Parse markdown link format: [text](url)
 * Returns { text, url } if match, null otherwise
 */
export const parseMarkdownLink = (suggestion: string): { text: string; url: string } | null => {
  const markdownLinkRegex = /^\s*(.+?)\s+\[(.+?)]\((https?:\/\/.+?)\)\s*$/;
  const match = suggestion.match(markdownLinkRegex);
  if (match) {
    const [, emoji, text, url] = match;
    return { text: `${emoji} ${text}`, url };
  }
  return null;
};

/**
 * Extract platform from URL for tracking
 */
export const getPlatformFromUrl = (url: string): 'lego' | 'rebrickable' | 'bricklink' | 'brickeconomy' | 'brickowl' | null => {
  if (url.includes('lego.com')) return 'lego';
  if (url.includes('rebrickable.com')) return 'rebrickable';
  if (url.includes('bricklink.com')) return 'bricklink';
  if (url.includes('brickeconomy.com')) return 'brickeconomy';
  if (url.includes('brickowl.com')) return 'brickowl';
  return null;
};
